<template>
    <div>
         <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
             <v-col xs="12" sm="12" lg="12" md="12" cols="12">
                 <center class="heading"><strong>Student Attendance Report</strong></center>
            <v-row>
                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Exam</label>
                    <v-autocomplete :items="exam_list" item-value="id" item-text="exam" v-model="exam" @change="findDates()" :rules="[v => !!v || 'required']" outlined dense placeholder="Select Exam" class="select"></v-autocomplete>
                </v-col>
                 <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Exam Date</label>
                    <v-autocomplete :items="dates" outlined dense placeholder="Select Exam Date"  v-model="date" :rules="[v => !!v || 'required']" class="select"></v-autocomplete>
                </v-col>
                 <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Exam Slot</label>
                    <v-autocomplete :items="slot_list" item-value="id" item-text="slot" outlined dense placeholder="Select Exam Slot"  v-model="slot"  class="select"></v-autocomplete>
                </v-col>
                 <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Year</label>
                    <v-autocomplete :items="year_list" item-value="id" item-text="year" v-model="year"  outlined dense placeholder="Select Year"  class="select"></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Program Type</label>
                    <v-autocomplete :items="program_type_list" item-value="id" item-text="program_type" v-model="prgramtype"  outlined dense placeholder="Select Program Type"  class="select"></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                    <label class="bold">Program</label>
                    <v-autocomplete :items="program_list" item-value="id" item-text="program" v-model="program"  outlined dense placeholder="Select Program" class="select"></v-autocomplete>
                </v-col>
                
            </v-row>
            <v-card-actions class="justify-center">
                        <v-btn :loading = "loader" class="mb-2 button btn" @click="fetchData()">Fetch</v-btn>
            </v-card-actions>
             </v-col>
        </v-card>
        <v-data-table v-if="display" :headers="headers1" :items="all_learner_data" sort-by class="elevation-1 mytable" :search="search" >
           <template v-slot:top>
                <v-toolbar flat dense color="white">
                    <download-excel :data="all_learner_data" worksheet="all_learner_data" :fields="data_list" name="Student_Attendance_Report.xls">
                        <v-btn color="success" class="ma-2 white--text downbtn">
                            <v-icon left dark>mdi-file-excel</v-icon>
                            export xls
                        </v-btn>
                    </download-excel>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                </v-text-field>
                </v-toolbar>
           </template>        
        </v-data-table>
    </div>
</template>
<script>
 import "@/assets/css/color.css";
  import axios from "axios";
  import moment from "moment";
export default {
    data() {
            return {
                loader: false,
                dates: [],
                arr: [],
                output_load: false,
                display:false,
                exam: "",
                proctor: "",
                sessionNo: "",
                date: "",              
                menu: false,
                examDate: "",
                snackbar_msg: "",
                snackbar: false,
                color: "",
                exam_list: [],
                program_list:[],
                program:"",
                program_type_list:[],
                prgramtype:"",
                year_list:[],
                year:"",
                slot_list:[],
                search:"",
                slot:"",
                all_learner_data:[],
                data_list: {
                    "Sr. No.": "srno",
                    "Exam" : "exam" ,
                    "Exam Date": "exam_date" ,
                    "Exam Slot" : "exam_slot" ,
                    "Year": "year", 
                    "Program Type" : "program_type" ,
                    "Program" : "program",
                    "Course Code" : "course_code",
                    "Course Name" : "course_name",
                    "Seat No" : "seat_number",
                    "Rgistration No" : "registration_number",
                    "Name": "name",
                    "Status": "status",
                },
                 headers1: [
                    { text: "Sr No", value: "srno" },
                    { text: "Exam", value: "exam" },
                    { text: "Exam Date", value: "exam_date" },
                    { text: "Exam Slot", value: "exam_slot" },
                    { text: "Year", value: "year" },
                    { text: "Program Type", value: "program_type" },
                    { text: "Program", value: "program" },
                    { text : "Course Code" , value: "course_code"},
                    { text: "Course Name", value: "course_name"},
                    { text: "Rgistration No.", value: "registration_number" },
                    { text: "Seat Number",value: "seat_number"},
                    { text: "Name", value: "name" },
                    { text: "Status", value: "status" },
                ],
            };
        },
        mounted() {
            this.onLoad();
        },
         methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
             onLoad() {
                axios
                    .post("/StudentAttendanceReport/getdeatils")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.exam_list = res.data.exam_list;
                           //  this.showSnackbar("success", "Load!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                    });
            },
            findDates() {
                const data = {
                    examId: this.exam,
                };
                axios
                    .post("/StudentAttendanceReport/getExamDate", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dates = res.data.dates;
                            this.program_list = res.data.program_list;
                            this.year_list = res.data.year_list;
                            this.program_type_list = res.data.program_type_list;
                            this.slot_list = res.data.slot_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            fetchData()
            {
                if (this.exam == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam.!!!");
                    return;
                }
                if (this.date == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam Date.!!!");
                    return;
                }
                 if (this.year == "") {
                    this.showSnackbar("#b71c1c", "Please Select Year.!!!");
                    return;
                }
                if (this.program == "") {
                    this.showSnackbar("#b71c1c", "Please Select Program.!!!");
                    return;
                }
                if (this.prgramtype == "") {
                    this.showSnackbar("#b71c1c", "Please Select Program Type.!!!");
                    return;
                }
                this.loader = true
                let newDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                 const data = {
                    exam: this.exam,
                    date: newDate,
                    year: this.year,
                    program: this.program,
                    program_type: this.prgramtype,
                    slot: this.slot
                };
                axios
                    .post("/StudentAttendanceReport/fetchdetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.display = true;
                            this.all_learner_data = res.data.all_learner_data;
                            this.loader = false
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            }
         }

    
}
</script>
<style  scoped>
.box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .date >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
      .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }
</style>